module.exports = __webpack_public_path__ + "img/PDAC1_NK.aed11f69.png";